export default class Conversions {
    
   // Converting UTC datetime to just time   Ex : 1900-01-01T17:00:00 -> 17:00 PM (24hours format to 12 hour)

      static UTCdatetoTime(UTCdate) {
        let Merdian, Hours, Minutes, Time, updatedMinutes,twelvehourformatHOUR = null;
        var dt = new Date(UTCdate + "Z");
        Hours = dt.getUTCHours();
        if (Hours < 12) { Merdian = ' AM'; } else { Merdian = ' PM'; }
        if (Hours > 12) { twelvehourformatHOUR = Hours - 12 ; } else { twelvehourformatHOUR = Hours; } // 24hour to 12 hour coversion
        Minutes = dt.getUTCMinutes();
        updatedMinutes = Minutes < 10 ? "0" + Minutes : Minutes;
        if(twelvehourformatHOUR==="0"){
          twelvehourformatHOUR="12"
        }
        Time = twelvehourformatHOUR + ":" + updatedMinutes + Merdian;
       //return Time;
        if(Time==="0:00 AM"  ) {return "12:00 AM"; } else {  return Time;}
      }

      // Converting Time to just Values for the slider { Ex: 8:00 AM - 17:00 PM  -> [480,1020] }    (24 hours to values)

      static Convert24hourTimetoValue(availabledate) {
        let  Hours, Minutes, Value = null;
        var dt = new Date(availabledate + "Z");
        Hours = dt.getUTCHours();
        Minutes = dt.getUTCMinutes();
        let hourspoints = Math.floor(Hours * 60);
        var minpoints = Minutes;
         Value = hourspoints+minpoints;
          return Value;
      }

   
      // Converting  Values from the slider to UTC format { Ex: [480,1020] } -> 8:00 AM - 17:00 PM       (values to 24 hour)

      static ConvertValueto24hourTime(value) {
        let hours = Math.floor(value / 60),
         minutes = value - (hours * 60);
        //  AMPM = hours >= 13 ? " PM" : " AM" 
         minutes = minutes < 10 ? "0" + minutes : minutes; 
         var now = new Date(); 
         now.setHours(hours);
         now.setMinutes(minutes);
         now.setSeconds("00");

         var isoDate = new Date(now - now.getTimezoneOffset() * 60000).toISOString();
         var resultFormatTime= isoDate.split('.')[0];
         return resultFormatTime ;
    //OUTPUT : 2015-02-20T19:29:31
    
      }

      static Weekdays(value) {
        var Weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        return Weekdays[value];
      }


      static HourPeriods() {
        var hour_periods = ["12:00 AM","12:15 AM","12:30 AM","12:45 AM","01:00 AM","01:15 AM","01:30 AM","01:45 AM","02:00 AM","02:15 AM","02:30 AM","02:45 AM","03:00 AM","03:15 AM","03:30 AM","03:45 AM","04:00 AM",
                            "04:15 AM","04:30 AM","04:45 AM","05:00 AM","05:15 AM","05:30 AM","05:45 AM","06:00 AM","06:15 AM","06:30 AM","06:45 AM","07:00 AM","07:15 AM","07:30 AM","07:45 AM","08:00 AM","08:15 AM",
                            "08:30 AM","08:45 AM","09:00 AM","09:15 AM","09:30 AM","09:45 AM","10:00 AM","10:15 AM","10:30 AM","10:45 AM","11:00 AM","11:15 AM","11:30 AM","11:45 AM",
                            "12:00 PM","12:15 PM","12:30 PM","12:45 PM","01:00 PM","01:15 PM","01:30 PM","01:45 PM","02:00 PM","02:15 PM","02:30 PM","02:45 PM","03:00 PM","03:15 PM","03:30 PM","03:45 PM","04:00 PM",
                            "04:15 PM","04:30 PM","04:45 PM","05:00 PM","05:15 PM","05:30 PM","05:45 PM","06:00 PM","06:15 PM","06:30 PM","06:45 PM","07:00 PM","07:15 PM","07:30 PM","07:45 PM","08:00 PM","08:15 PM",
                            "08:30 PM","08:45 PM","09:00 PM","09:15 PM","09:30 PM","09:45 PM","10:00 PM","10:15 PM","10:30 PM","10:45 PM","11:00 PM","11:15 PM","11:30 PM","11:45 PM"];
       
       
                            return hour_periods;
      }


      //Converting 12:00 Am to 24 hour format
      static convertTo24Hour(time12h) {
        const [time, modifier] = time12h.split(' ');
        let [hours, minutes] = time.split(':');
        if (hours === '12') {
          hours = '00';
        }
        if (modifier === 'PM') {
          hours = parseInt(hours, 10) + 12;
        }
        var now = new Date(); 
        now.setHours(hours);
        now.setMinutes(minutes);
        now.setSeconds("00");
        var isoDate = new Date(now - now.getTimezoneOffset() * 60000).toISOString();
        var resultFormatTime= isoDate.split('.')[0];

      var resultvalue=  Conversions.Convert24hourTimetoValue(resultFormatTime)
        return resultvalue ;

      }




  // Round the values Ex 10 ->10.00, 5.30 ->5.30
  static roundValues(num) {
    var value = Number(num);
    var res = num.split(".");
    if (res.length === 1 || (res[1].length < 3)) {
      value = value.toFixed(2);
    }
    return value
  }

  static getFooterTime(){
    let months,dateObj,month,day,year,new_date,hh,m,s,dd,h= null;
     months = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sep", "Oct", "Nov", "Dec" ];
     dateObj = new Date();
     month = months[dateObj.getMonth()]; 
     day = dateObj.getUTCDate();
     year = dateObj.getUTCFullYear();
     hh = dateObj.getHours();
     m = dateObj.getMinutes();
     s = dateObj.getSeconds();
     dd = "AM";
     h = hh;
    if (h >= 12) {  h = hh - 12;  dd = "PM"; }
    if (h === 0) { h = 12; }
    m = m < 10 ? "0" + m : m;
    s = s < 10 ? "0" + s : s;
    new_date = month+" "+ day +" "+ year+" "+h + ":" + m +" "+ s +" " + dd;
     return new_date;
  }

  //Convert 24 Hours to 12 Hours Format
  static GetTimeString(date){
    var dt = date; 
    var d1 = dt.split('T')[1]; 
    var d2 = d1.split(':'); 
    var datestr = this.convertTo12Hour(d2[0]+':'+d2[1]);
    return datestr;
  }

  static GetDateString(date){
    var dt = date; 
    var d1 = dt.split('T')[0]; 
    var d2 = d1;
    if(d1.indexOf("-") >= 0){
     d2 = d1.replace(/-/g, '/')
    }
    return d2 + ' 00:00:00';
  }

  static convertTo12Hour(Time){
    let Merdian, Hours, Minutes, twelvehourformatHOUR = null, Value;
    Hours = Number(Time.split(':')[0]);
    Minutes = Time.split(':')[1];
    if (Hours < 12) { 
      Merdian = ' AM'; 
      twelvehourformatHOUR = Hours;
    } 
    else { 
      Merdian = ' PM'; 
      twelvehourformatHOUR = Hours - 12;
    }
    twelvehourformatHOUR = twelvehourformatHOUR === 0 ? 12 : twelvehourformatHOUR;
    Value = twelvehourformatHOUR + ":" + Minutes + Merdian;
    return Value;
  }

  static DateFormatBasedOnUserPreference(PreferedDateFormat, date){
    let DtSeperator, DtFormat;
    var FDate = new Date(date);
    var year = FDate.getFullYear();
    var month = FDate.getMonth() + 1;
    var dt = FDate.getDate();

    month = Number(month) <= 9 ? "0"+month : month; 
    dt = Number(dt) <= 9 ? "0"+dt : dt;

    switch (PreferedDateFormat.dateSeparators) {
      case 0: DtSeperator = '-';
        break;
      case 1: DtSeperator = '/';
        break;
      case 2: DtSeperator = '.';
        break;
      case 3: DtSeperator = '_';
        break;
      default: DtSeperator = '-';
        break;
    }
    switch (PreferedDateFormat.dateFormat) {
      case 0: DtFormat = month+DtSeperator+dt+DtSeperator+year;
        break;
      case 1: DtFormat = dt+DtSeperator+month+DtSeperator+year;
        break;
      case 2: DtFormat = year+DtSeperator+month+DtSeperator+dt;
        break;
      default: DtFormat = month+DtSeperator+dt+DtSeperator+year;
        break;
    }
    return DtFormat;    
}
static UserPreferenceDateFormat_DatePicker(PreferedDateFormat){
  let DtSeperator = this.GetPreferedFormatDateSeperator(PreferedDateFormat); 
  let DtFormat;
  switch (PreferedDateFormat.dateFormat) {
    case 0: DtFormat = 'MM'+DtSeperator+'dd'+DtSeperator+'yyyy';
      break;
    case 1: DtFormat = 'dd'+DtSeperator+'MM'+DtSeperator+'yyyy'; 
      break;
    case 2: DtFormat = 'yyyy'+DtSeperator+'MM'+DtSeperator+'dd'; 
      break;
    default: DtFormat = 'MM'+DtSeperator+'dd'+DtSeperator+'yyyy';
      break;
  }
  return DtFormat; 
}
   static UserPreferenceDateFormat(PreferedDateFormat){
    let DtSeperator = this.GetPreferedFormatDateSeperator(PreferedDateFormat); 
    let DtFormat;
    switch (PreferedDateFormat.dateFormat) {
      case 0: DtFormat = 'm'+DtSeperator+'d'+DtSeperator+'Y';
        break;
      case 1: DtFormat = 'd'+DtSeperator+'m'+DtSeperator+'Y'; 
        break;
      case 2: DtFormat = 'Y'+DtSeperator+'m'+DtSeperator+'d'; 
        break;
      default: DtFormat = 'm'+DtSeperator+'d'+DtSeperator+'Y';
        break;
    }
    return DtFormat;  
   }  

   static GetPreferedFormatDateSeperator(PreferedDateFormat){
    let DtSeperator;
    
    switch (PreferedDateFormat.dateSeparators) {
      case 0: DtSeperator = '-';
        break;
      case 1: DtSeperator = '/';
        break;
      case 2: DtSeperator = '.';
        break;
      case 3: DtSeperator = '_';
        break;
      default: DtSeperator = '-';
        break;
    }
    return DtSeperator;
   }
   static GetPreferedFormatSeperator(PreferedFormats){
     let NumberFormat;
    switch (PreferedFormats.numberFormatText) {
      case 'Dot': NumberFormat = [',','.'];
        break;
      case 'Comma': NumberFormat = [' ',','];
        break;
      case 'DotComma': NumberFormat = ['.',','];
        break;
      case 'NoSpaceDot': NumberFormat = ['','.']; 
        break;
      case 'NoSpaceComma':NumberFormat = ['',','];
        break;
      default: NumberFormat = [',','.'];
        break;
    }
    return NumberFormat;
   }

   static formatNumber(PreferedFormats, number){
    let Seperators =  this.GetPreferedFormatSeperator(PreferedFormats);
    let GroupSeperator = Seperators[0];
    let DecimalSeparator = Seperators[1];
    var n = number,j;
    var c =  2;
    var d = DecimalSeparator;
    var t = GroupSeperator;
    var s = n < 0 ? "-" : "";
    var i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "";
    j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
   }
   static formatNumberASU(PreferedFormats, number){
    let Seperators =  this.GetPreferedFormatSeperator(PreferedFormats);
    let GroupSeperator = Seperators[0];
    let DecimalSeparator = Seperators[1];
    var n = number,j;
    var c =  4;
    var d = DecimalSeparator;
    var t = GroupSeperator;
    var s = n < 0 ? "-" : "";
    var i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "";
    j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
   }
   static formatNumberAHrs(PreferedFormats, number){
    let Seperators =  this.GetPreferedFormatSeperator(PreferedFormats);
    let GroupSeperator = Seperators[0];
    let DecimalSeparator = Seperators[1];
    var n = number,j;
    var c =  1;
    var d = DecimalSeparator;
    var t = GroupSeperator;
    var s = n < 0 ? "-" : "";
    var i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "";
    j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
   }

   static getInvariantNumber(PreferedFormats, number){
     let Seperators = this.GetPreferedFormatSeperator(PreferedFormats);
     let GroupSeperator = Seperators[0];
     let DecimalSeparator = Seperators[1];
     var v = number;
     var d = DecimalSeparator;
     var t = GroupSeperator;
     if (t === '.') {
       v = v.replace(d, '$').trim();
     }
     for (var i = 0; i < v.length; i++) {
       v = v.replace(t, '').replace(d, '.').trim();
     }
     v = v.replace('$', '.');
     var l_Return = v;

     return isNaN(l_Return) ? 0 : parseFloat(l_Return);
   }

   static getInvariantNumberForAH(PreferedFormats, number){
    let Seperators = this.GetPreferedFormatSeperator(PreferedFormats);
    let GroupSeperator = Seperators[0];
    let DecimalSeparator = Seperators[1];
    var v = number;
    var d = DecimalSeparator;
    var t = GroupSeperator;
    if (t === '.') {
      v = v.replace(d, '$').trim();
    }
    for (var i = 0; i < v.length; i++) {
      v = v.replace(t, '').replace(d, '.').trim();
    }
    v = v.replace('$', '.');
    var l_Return = v;

    return isNaN(l_Return) ? 'NaN' : parseFloat(l_Return);
  }

   static MonthNames(value) {
    var MonthNames = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return MonthNames[value];
  }
}





